// Auth funnel analytics (login experiment, z94kydcrz3).
//
// Before this, login success was unmeasurable: the form submits over XHR, so
// GA4's automatic form_submit almost never fired, and nothing reported a
// successful or failed login. Every event here goes to GTM's dataLayer tagged
// with the experiment arm (set by the inline script in base.hbs), and is also
// re-dispatched as a DOM event so the v2 page script can react to it.
//
// Never put the email, name or password in an event.

const AUTH_EVENT = "sc:auth";

function loginVariant() {
  return (typeof window !== "undefined" && window.__LOGIN_VARIANT__) || "";
}

/** Milliseconds since navigation start: the "time to authenticate" metric. */
function msSincePageLoad() {
  try {
    return Math.round(window.performance.now());
  } catch (e) {
    return null;
  }
}

function trackAuth(event, params) {
  const payload = Object.assign({ event }, params || {});
  const variant = loginVariant();
  if (variant) payload.login_variant = variant;
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  } catch (e) {
    // Analytics must never break auth.
  }
  try {
    window.dispatchEvent(
      new CustomEvent(AUTH_EVENT, { detail: { event, params: params || {} } }),
    );
  } catch (e) {
    // Old browsers without CustomEvent: the dataLayer push above still ran.
  }
}

/**
 * Map a failed /auth/local/signin response to a reason that does not leak
 * which accounts exist beyond what the page already tells the person.
 */
function signinFailureReason(xhr) {
  const status = xhr && xhr.status;
  const body = (xhr && xhr.responseJSON) || {};
  const error = body.error || {};
  if (!status) return "network";
  if (error.isScheduledForDeletion) return "scheduled_for_deletion";
  if (status === 409 && error.code === "PASSWORD_NOT_SET") {
    return "password_not_set";
  }
  if (status === 403 && error.ssoEnforced) return "sso_enforced";
  if (status === 403 && error.token) return "verification_required";
  if (status === 401) return "invalid_credentials";
  if (status === 429) return "rate_limited";
  if (status === 400) return "rejected";
  if (status >= 500) return "server_error";
  return "other";
}

const AUTH_PAGE = /^\/(?:ar\/)?(login|signup|forgot-password|sso-login)\/?$/;

/**
 * Which sign-in method a click chose: "google" for the Google button, "sso"
 * for a link to the SSO page, otherwise null. Shared by control and every
 * experiment arm so the method mix is counted the same way on all of them.
 */
function authMethodOf(target) {
  if (!target || typeof target.closest !== "function") return null;
  if (target.closest("#federated-google-button")) return "google";
  const link = target.closest("a[href]");
  const href = link ? link.getAttribute("href") || "" : "";
  if (/^\/(?:ar\/)?sso-login(?:[?#]|$)/.test(href)) return "sso";
  return null;
}

/**
 * auth_method_click on the auth pages, control included (z94kydcrz3).
 * Google and SSO sign-ins finish on the server, which redirects straight to
 * the app, so their success is not measured yet; the click is the comparable
 * signal of which method each arm's visitors chose.
 */
function trackAuthMethodClicks(doc, location) {
  const match = AUTH_PAGE.exec((location && location.pathname) || "");
  if (!match || !doc) return;
  doc.addEventListener(
    "click",
    (event) => {
      const method = authMethodOf(event.target);
      if (method) trackAuth("auth_method_click", { method, page: match[1] });
    },
    true,
  );
}

module.exports = {
  AUTH_EVENT,
  authMethodOf,
  trackAuthMethodClicks,
  loginVariant,
  msSincePageLoad,
  signinFailureReason,
  trackAuth,
};
